/**
 * Created by 陈浩 2018-05-14 11:24:47
 */
'use strict';
angular.module('editCenNewspaperTextDesignationModule', []).controller('editCenNewspaperTextDesignationCtrl', ['$scope', '$modalInstance', 'trsHttpService', '$sessionStorage', 'initVersionService', 'modalDialog', 'item',
    function($scope, $modalInstance, trsHttpService, $sessionStorage, initVersionService, modalDialog, item) {
        initData();

        /**
         * [initData description]
         *
         * @return  {[type]}   [return description]
         */
        function initData() {
            $scope.status = {
                canConfirm: item.hasConfirmRight // 是否有通过评审的权限
            };
            $scope.data = {
                typeObj: {
                    text: '1',
                    video: '2',
                    image: '3'
                },
                content: '通过',
                info: [],
                audioObj: {},
                userId: $sessionStorage.get('curUserInfo').ID
            };
            queryDaYangReviews();
        }

        /**
         * [queryDaYangReviews description]
         *
         * @return  {[type]}   [return description]
         */
        function queryDaYangReviews() {
            var params = {
                'serviceid': 'mlf_paper',
                'methodname': 'queryDaYangReviews',
                'ComposeId': item.id
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.data.info = initVersionService.getDayContent(data.DATA, 'push');
            });
        }


        /**
         * [deleteOpinion description] 删除评审意见
         *
         * @param  {[type]}  review   [review description]
         *
         * @return  {[type]}   [return description]
         */
        $scope.deleteOpinion = function(review) {
            modalDialog.confirmModal('提示', '是否确认删除评审意见？', function () {
                var params = {
                    ComposeId: review.COMPOSEID,
                    ComposeReviewid: review.COMPOSEREVIEWID,
                    methodname: 'deleteDaYangReview',
                    serviceid: 'mlf_paper'
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    queryDaYangReviews();
                    modalDialog.alertType(data.DETAIL, '', 'success', false);
                });
            });
        };

        /**
         * [edit description] 编辑某一条意见，主要是拷贝该意见，在取消编辑时还原该意见
         *
         * @param  {[type]}  item   [item description]
         *
         * @return  {[type]}   [return description]
         */
        $scope.edit = function(item) {
            item.REVIEWCONTENTCOPY = item.REVIEWCONTENT;
            item.isEdit = true;
        };

        /**
         * [cancelEdit description] 取消编辑某一条意见并还原该意见
         *
         * @param  {[type]}  item   [item description]
         *
         * @return  {[type]}   [return description]
         */
        $scope.cancelEdit = function(item) {
            item.REVIEWCONTENTCOPY = undefined;
            item.isEdit = false;
        };

        $scope.textFormat = function(text) {
            return text.replace(/\n/g, '<br/>').replace(/\s/g, '&nbsp;');
        };

        /**
         * [cancel description] 取消按钮
         *
         * @return  {[type]}   [return description]
         */
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };

        /**
         * [confirm description] 确认按钮
         *
         * @param  {[type]}  review   [review description]
         *
         * @return  {[type]}   [return description]
         */
        $scope.confirm = function(review) {
            if (!review || !review.REVIEWCONTENTCOPY || review.REVIEWCONTENTCOPY.length > 500) {
                return;
            }
            var params = {
                'serviceid': 'mlf_paper',
                'methodname': 'reviewDaYang',
                'DyFileName': item.path,
                'ComposeId': item.id,
                'ComposeReviewID': review.COMPOSEREVIEWID || 0,
                'ReviewContent': review.REVIEWCONTENTCOPY,
                'ReviewRect': '1,2,3,4',
                'ReviewType': 1
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                queryDaYangReviews();
                var oper = review.COMPOSEREVIEWID ? '修改' : '添加';
                modalDialog.alertType(oper + '评审意见成功', '', 'success', false);
            });
        };

        /**
         * [showBigPicture description] 全屏展示大样备注图片
         *
         * @param  {[type]}  value   [value description]
         *
         * @return  {[type]}   [return description]
         */
        $scope.showBigPicture = function(value) {
            var dynamicEl = [];
            dynamicEl[0] = {
                src: value.DYFILENAME,
                thumb: value.DYLITTLEFILE,
                subHtml: '大样批注'
            };
            $(this).lightGallery({
                thumbnail: true,
                dynamic: true,
                dynamicEl: dynamicEl,
                showThumbByDefault: false,
                thumbWidth: 200,
                thumbHeight: '200px',
            });
        };
    }
]);
